import { LegalScreen } from '@/components/legal/LegalScreen'

export default function PrivacyPolicyRoute() {
  return <LegalScreen slug="privacy-policy" />
}
